(function () {
  if (window.__siteHeaderBound) return;
  window.__siteHeaderBound = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.dh').forEach(function (dh) {
      // Announcement close
      var ann = dh.querySelector('.dh-announce');
      var annClose = dh.querySelector('.dh-announce__close');
      if (annClose && ann) {
        annClose.addEventListener('click', function () { ann.hidden = true; });
      }

      // Sticky: expose the announcement-bar height so CSS can offset the sticky
      // header by it (the announce scrolls away, the main bar pins). Pure CSS
      // handles the motion — no scroll listener needed.
      if (dh.classList.contains('dh--sticky') && ann) {
        // Set the var on the SECTION wrapper (the sticky element): CSS custom
        // properties inherit to descendants, so the section can't read a var
        // set on its child .dh.
        var stickyEl = dh.parentElement;
        var setAnnH = function () {
          stickyEl.style.setProperty('--dh-announce-h', (ann.hidden ? 0 : ann.offsetHeight) + 'px');
        };
        setAnnH();
        window.addEventListener('resize', setAnnH);
        if (annClose) annClose.addEventListener('click', setAnnH);
      }

      // Search toggle
      var searchBtn = dh.querySelector('.dh-search-toggle');
      var search = dh.querySelector('.dh-search');
      if (searchBtn && search) {
        searchBtn.addEventListener('click', function () {
          search.hidden = !search.hidden;
          if (!search.hidden) {
            var input = search.querySelector('input');
            if (input) input.focus();
          }
        });
      }

      // Mobile drawer (slide-in side panel)
      var burger = dh.querySelector('.dh-burger');
      var drawer = dh.querySelector('.dh-drawer');
      if (burger && drawer) {
        var openDrawer = function () {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        };
        var closeDrawer = function () {
          drawer.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };
        burger.addEventListener('click', openDrawer);
        drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
          el.addEventListener('click', closeDrawer);
        });
        // accordion: toggle submenus for items that have children
        drawer.querySelectorAll('.dh-drawer__toggle').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var item = btn.closest('.dh-drawer__item');
            var open = item.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        });
        // close after tapping any nav link (it navigates away anyway)
        drawer.querySelectorAll('.dh-drawer__link, .dh-drawer__sublink').forEach(function (el) {
          el.addEventListener('click', closeDrawer);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
        });
      }

      // Mega menu — click toggles on touch/mobile (hover handles desktop via CSS)
      dh.querySelectorAll('.dh-has-mega > .dh-nav__link--mega').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var isTouch = window.matchMedia('(hover: none)').matches || window.innerWidth < 991;
          if (isTouch) {
            e.preventDefault();
            link.parentElement.classList.toggle('is-open');
          }
        });
      });
    });

    // Desktop nav takeover popup (shared) — open via [data-takeover-open], close via X / Esc.
    var takeover = document.querySelector('[data-nav-takeover]');
    if (takeover) {
      var openTakeover = function () {
        takeover.classList.add('show');
        takeover.setAttribute('aria-hidden', 'false');
        document.body.classList.add('scroll-lock');
        document.body.style.overflow = 'hidden';
      };
      var closeTakeover = function () {
        takeover.classList.remove('show');
        takeover.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('scroll-lock');
        document.body.style.overflow = '';
      };
      document.querySelectorAll('[data-takeover-open]').forEach(function (b) {
        b.addEventListener('click', openTakeover);
      });
      takeover.querySelectorAll('[data-takeover-close]').forEach(function (el) {
        el.addEventListener('click', closeTakeover);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && takeover.classList.contains('show')) closeTakeover();
      });
    }
  });
})();
